import CreateAccount from '../pages/login/components/createAccount';

const baseUrl = process.env.APP_BASEURL;
console.log('baseUrl api', baseUrl);
export const loginApi = {
  SendSMSVerifyCode: baseUrl + '/api/v1/Login/SendSMSVerifyCode',
  SingleSignOnByPhones: baseUrl + '/api/v1/Login/SingleSignOnByPhones',
  SingleSignOnByLoginId: baseUrl + '/api/v1/Login/SingleSignOnByLoginId',
  SignOut: baseUrl + '/auth/logout',
  register: baseUrl + '/auth/register',
  checkAccount: baseUrl + '/auth/check_account',
  sendEmailCode: baseUrl + '/auth/send_verification_email',
  loginEmailCode: baseUrl + '/auth/send_verification_email',
  checkEmailCode: baseUrl + '/auth/check_email_code',
  signIn: baseUrl + '/auth/login',
  resetPassword: baseUrl + '/auth/reset_password',
  fogotPassword: baseUrl + '/auth/forgot_password',
  verificationLogin: baseUrl + '/auth/verification_login',
  // Google OAuth endpoints
  googleAuth: baseUrl + '/auth/google',
  googleCallback: baseUrl + '/auth/google/callback',
  // Direct token authentication
  tokenCallback: baseUrl + '/auth/callback',
  // ResetPassword: baseUrl + '/api/v1/Login/ResetPassword',
  // GetAuthMenuTiers: baseUrl + '/api/v1/Menu/GetAuthMenuTiersByProject',
  // GetMenuByRole: `${baseUrl}/api/v1/Menu/GetMenuByRole`,
  // UserInfo: baseUrl + '/api/v1/User/Info',
};
